/**
 * Mapa gier konsoli — lustrzana kopia logiki hubu (§13.2 / §13.3).
 * Nie importujemy z phone/ (osobna własność WP11, wspólny kontrakt shared).
 */
import { gamesForHub, type GameId, type MinigameDef } from '@pieskowo/shared';
import { getSceneRouter } from '../core/SceneRouter.js';

export const GAME_SCENE_KEYS: Record<GameId, string> = {
  rhythm: 'MgRhythm',
  cooking: 'MgCooking',
  runner: 'MgRunner',
  bubbles: 'MgBubbles',
  puzzle: 'MgPuzzle',
  swimrace: 'MgSwimRace',
};

export const GAME_ICONS: Record<GameId, string> = {
  rhythm: '🎵',
  cooking: '🦴',
  runner: '🏃',
  bubbles: '🫧',
  puzzle: '🧩',
  swimrace: '🏊',
};

export function listConsoleGames(): MinigameDef[] {
  return gamesForHub('console');
}

export function launchConsoleGame(gameId: GameId): void {
  const key = GAME_SCENE_KEYS[gameId];
  if (!key) return;
  getSceneRouter().go(key, { entryPoint: 'console' as const, gameId });
}
